import { render } from "./NavItemAddIcon.vue?vue&type=template&id=9caa5e08"
import script from "./NavItemAddIcon.vue?vue&type=script&lang=js"
export * from "./NavItemAddIcon.vue?vue&type=script&lang=js"

import "./NavItemAddIcon.vue?vue&type=style&index=0&id=9caa5e08&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__